module.exports = __webpack_public_path__ + "img/frameBackgroundImg.6948c112.png";